import React, { useState, useEffect, useContext } from 'react';
import { Button } from '@material-ui/core';
import PDFIcon from '@material-ui/icons/PictureAsPdf';
import PrintIcon from '@material-ui/icons/Print';
import IntellipayLogo from '../images/intellipay-dark.png';
import SpanishLogo from '../images/spanishfork.png';

import { Context as PortalContext } from '../context/portal.context';

const Invoice = (props) => {
  const { state } = useContext(PortalContext);

  return (
    <>
      {true ? ( //state.externalProvider !== 'caselle'
        <div className="invoice-container">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <img
                src={IntellipayLogo}
                height={60}
                className="logo"
                alt="logo"
              />
              <span
                style={{
                  paddingTop: 10,
                  paddingBottom: 10,
                  borderTop: "1px solid black",
                  borderBottom: "1px solid black",
                }}
              >
                {props.date}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
              }}
            >
              <div
                style={{
                  height: 15,
                  width: 300,
                  background: "#ECF1F6",
                  marginTop: 20,
                }}
              />
              <div className="lineItem">
                <span><x-lang>Invoice Amount</x-lang></span>
                <span>
                  ${(parseFloat(props.due) + parseFloat(props.paid)).toFixed(2)}
                </span>
              </div>
              <div className="lineItem">
                <span><x-lang>Amount Paid</x-lang></span>
                <span>${props.paid}</span>
              </div>
              <div className="divider" />
              <div className="lineItem">
                <span style={{ fontWeight: "bold", fontSize: 18 }}>
                <x-lang>Balance Due</x-lang>
                </span>
                <span style={{ fontWeight: "bold", fontSize: 18 }}>
                  ${props.due}
                </span>
              </div>
            </div>
          </div>
          <div className="tableHeader">
            <span><x-lang>Date</x-lang></span>
            <span><x-lang>Description</x-lang></span>
          </div>
          <div className="tableRow">
            <span style={{ fontWeight: "bold" }}>{props.date}</span>
            <span style={{ fontWeight: "bold" }}>
            <x-lang>Amount Due</x-lang>: $
              {(parseFloat(props.due) + parseFloat(props.paid)).toFixed(2)}
            </span>
          </div>
        </div>
      ) : (
        <div style={styles.container}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div>
              <img
                src={state.merchantLogoURL}
                width={200}
                style={styles.logo}
                alt="logo"
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <span>{state.merchantName}</span>
              <b>{state.merchantAddress}</b>
              <b>{state.merchantAddress2}</b>
              <b>
                {state.merchantCity}, {state.merchantState}, {state.merchantZip}
              </b>
              {typeof props.data.customer !== "undefined" ? (
                <b>{props.data.customer.contactInfo.telephone1}</b>
              ) : (
                ""
              )}
              <span>{state.merchantPhone}</span>
              {/* <span>Monday to Friday 8:00 am to 5:00 pm</span> */}
            </div>
          </div>
          <div
            style={{
              ...styles.row,
              width: "100%",
              borderTop: "1px solid #dddddd",
              borderBottom: "1px solid #dddddd",
              alignItems: "center",
              marginTop: 40,
              paddingTop: 10,
              paddingBottom: 10,
            }}
          >
            <span style={{ width: "100%" }}>
              <b><x-lang>Total Amount Due</x-lang>: ${props.data.customer.accountBalance}</b>
            </span>
            <div
              style={{
                ...styles.row,
                justifyContent: "flex-end",
              }}
            >
              {/* <Button
						variant="outlined"
						startIcon={<PrintIcon />}
						style={{ marginRight: 10 }}
					>
						Print
					</Button>
					<Button
						variant="outlined"
						startIcon={<PDFIcon />}
						style={{ marginRight: 10 }}
					>
						Download PDF
					</Button>
					<Button variant="contained" color="primary">
						Pay This Bill
					</Button> */}
            </div>
          </div>
          <div style={styles.row}>
            <div
              style={{
                ...styles.column,
                marginRight: 25,
                width: 600,
              }}
            >
              <div
                style={{
                  ...styles.row,
                  marginTop: 25,
                  marginBottom: 25,
                }}
              >
                <div style={styles.column}>
                  <b><x-lang>Billing Address</x-lang></b>
                  <span>{props.data.customer.name}</span>
                  <span>{props.data.customer.contactInfo.address1}</span>
                  <span>
                    {props.data.customer.contactInfo.city},{" "}
                    {props.data.customer.contactInfo.state}{" "}
                    {props.data.customer.contactInfo.zip}
                  </span>
                </div>
                <div style={styles.column}>
                  <b><x-lang>Service Address</x-lang></b>
                  <span>{props.data.customer.location.address}</span>
                  <span>
                    {props.data.customer.location.city},{" "}
                    {props.data.customer.location.state}{" "}
                    {props.data.customer.location.zip}
                  </span>
                </div>
              </div>
              <table style={styles.table}>
                <tr
                  style={{
                    ...styles.tr,
                    background: "#ECF1F6",
                  }}
                >
                  <th style={styles.th}><x-lang>Description</x-lang></th>
                  <th style={styles.th}><x-lang>Read Date</x-lang></th>
                  <th style={styles.th}><x-lang>Prev Reading</x-lang></th>
                  <th style={styles.th}><x-lang>Present Reading</x-lang></th>
                  <th style={styles.th}><x-lang>Total Usage</x-lang></th>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.tdc}>EL</td>
                  <td style={styles.tdc}>
                    {props.data.activities.Electric["267331KJ"][0].periodDate}
                  </td>
                  <td style={styles.tdc}>1,535</td>
                  <td style={styles.tdc}>1,635</td>
                  <td style={styles.tdc}>100</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.tdc}>WA</td>
                  <td style={styles.tdc}>02/29/2021</td>
                  <td style={styles.tdc}>97</td>
                  <td style={styles.tdc}>115</td>
                  <td style={styles.tdc}>18</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.tdc}>MP</td>
                  <td style={styles.tdc}>02/27/2021</td>
                  <td style={styles.tdc}>100</td>
                  <td style={styles.tdc}>135</td>
                  <td style={styles.tdc}>35</td>
                </tr>
              </table>
              <div
                style={{
                  ...styles.column,
                  width: "100%",
                  border: "1px solid #ddd",
                  marginTop: 25,
                  padding: 8,
                  boxSizing: "border-box",
                }}
              >
                <b style={{ marginBottom: 8 }}><x-lang>Cable TV Details</x-lang>:</b>
                <span>2020-12-21 - <x-lang>BASIC SERVICE</x-lang> ($27.83/MONTH) - $27.83</span>
                <span>2020-12-21 - DTA <x-lang>CREDIT</x-lang> ($-2.00/MONTH) - $-2.00</span>
                <span>2020-12-21 - DTA <x-lang>CREDIT</x-lang> ($-2.00/MONTH) - $-2.00</span>
                <span>2020-12-21 - <x-lang>FRANCHISE FEE</x-lang> - $1.49</span>
                <span>2020-12-21 - <x-lang>SALES TAX</x-lang> - $0.14</span>
                <span>2020-12-21 - MCVA <x-lang>SERVICE TAX</x-lang> - $1.83</span>
                <span>2020-12-21 - MCVA <x-lang>TAX CREDIT</x-lang> - $-0.74</span>
              </div>
              <div style={{ ...styles.column, marginTop: 25 }}>
                <div style={styles.row}>
                  <b><x-lang>Previous Payment Date</x-lang>:</b>
                  <span>01/20/2021</span>
                </div>
                <div style={styles.row}>
                  <b><x-lang>Previous Payment Amount</x-lang>:</b>
                  <span>$232.43</span>
                </div>
                <div style={styles.row}>
                  <b><x-lang>Garbage Cans</x-lang>:</b>
                  <span>1</span>
                </div>
                <div style={styles.row}>
                  <b><x-lang>Recycle Cans</x-lang>:</b>
                  <span>1</span>
                </div>
                <div style={styles.row}>
                  <b><x-lang>Net Metering Information</x-lang>:</b>
                  <span><x-lang>Quantity</x-lang></span>
                </div>
                <div style={styles.row}>
                  <b><x-lang>Beginning Stored</x-lang> kWh:</b>
                  <span>-1674</span>
                </div>
                <div style={styles.row}>
                  <b>kWh <x-lang>Produced</x-lang>:</b>
                  <span>201</span>
                </div>
                <div style={styles.row}>
                  <b>kWh <x-lang>Available</x-lang>:</b>
                  <span>-1875</span>
                </div>
                <div style={styles.row}>
                  <b>kWh <x-lang>Consumed</x-lang>:</b>
                  <span>1237</span>
                </div>
                <div style={styles.row}>
                  <b>kWh <x-lang>Forfeited</x-lang>:</b>
                  <span>.00</span>
                </div>
                <div style={styles.row}>
                  <b>kWh <x-lang>Billed or Stored Credit</x-lang>:</b>
                  <span>-638</span>
                </div>
              </div>
              {/* <Bar
						data={data}
						options={options}
						style={{ marginTop: 40 }}
					/> */}
            </div>

            <div style={styles.column}>
              <span style={styles.tableHeader}><x-lang>Account Information</x-lang></span>
              <table style={styles.table}>
                <tr style={styles.tr}>
                  <td style={styles.td}><x-lang>Billing Period End</x-lang>:</td>
                  <td style={styles.tdc}>01/20/2021</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td}><x-lang>Due Date</x-lang>:</td>
                  <td style={styles.tdc}>02/20/2021</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td}><x-lang>Account</x-lang> #:</td>
                  <td style={styles.tdc}>
                    {props.data.customer.customerNumber}
                  </td>
                </tr>
              </table>
              <span style={styles.tableHeader}><x-lang>Total Charges</x-lang></span>
              <table style={styles.table}>
                <tr style={styles.tr}>
                  <td style={styles.td}><x-lang>ELECTRIC</x-lang>:</td>
                  <td style={{ ...styles.td, width: 150 }}>$14.50</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td}><x-lang>METERED PI</x-lang>:</td>
                  <td style={{ ...styles.td, width: 150 }}>$11.34</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td}><x-lang>CULINARY WATER</x-lang>:</td>
                  <td style={{ ...styles.td, width: 150 }}>$15.70</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td}><x-lang>SEWER</x-lang>:</td>
                  <td style={{ ...styles.td, width: 150 }}>$33.32</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td}><x-lang>GARBAGE</x-lang>:</td>
                  <td style={{ ...styles.td, width: 150 }}>$12.90</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td}><x-lang>RECYLCE CAN</x-lang>:</td>
                  <td style={{ ...styles.td, width: 150 }}>$6.46</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td}><x-lang>STORM DRAIN</x-lang>:</td>
                  <td style={{ ...styles.td, width: 150 }}>$9.82</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td}><x-lang>INTERNET</x-lang>:</td>
                  <td style={{ ...styles.td, width: 150 }}>$75.00</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td}><x-lang>CABLE TV</x-lang>:</td>
                  <td style={{ ...styles.td, width: 150 }}>$30.55</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td}><x-lang>MUNICIPAL ENERGY TAX</x-lang>:</td>
                  <td style={{ ...styles.td, width: 150 }}>$0.88</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td}><x-lang>UTAH SALES TAX-ELEC</x-lang>:</td>
                  <td style={{ ...styles.td, width: 150 }}>$0.65</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td}><x-lang>PHONE</x-lang>:</td>
                  <td style={{ ...styles.td, width: 150 }}>$14.95</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td}><x-lang>FEDERAL ACCESS FEE</x-lang>:</td>
                  <td style={{ ...styles.td, width: 150 }}>$1.50</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td}>911 - <x-lang>STATE OF UTAH</x-lang>:</td>
                  <td style={{ ...styles.td, width: 150 }}>$0.25</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td}>911 - <x-lang>COUNTY/CITY</x-lang>:</td>
                  <td style={{ ...styles.td, width: 150 }}>$0.71</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td}><x-lang>POISON CONTROL</x-lang>:</td>
                  <td style={{ ...styles.td, width: 150 }}>$0.52</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td}><x-lang>RECOVERY CITY TELECOM TAX</x-lang>:</td>
                  <td style={{ ...styles.td, width: 150 }}>$0.52</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td}><x-lang>STATE UNIVERSAL SERVICE FUND</x-lang>:</td>
                  <td style={{ ...styles.td, width: 150 }}>$0.60</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td}><x-lang>PHONE STATE SALES TAX</x-lang>:</td>
                  <td style={{ ...styles.td, width: 150 }}>$0.75</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td}><x-lang>PHONE CITY/COUNTY SALES TAX</x-lang>:</td>
                  <td style={{ ...styles.td, width: 150 }}>$0.33</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td}><x-lang>MASS TRANSIT SALES TAX</x-lang>:</td>
                  <td style={{ ...styles.td, width: 150 }}>$0.04</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td}><x-lang>FEDERAL EXCISE TAX</x-lang>:</td>
                  <td style={{ ...styles.td, width: 150 }}>$0.53</td>
                </tr>
                <tr style={styles.tr}>
                  <td style={styles.td}><x-lang>FEDERAL UNIVERSAL SERVICE FUND</x-lang>:</td>
                  <td style={{ ...styles.td, width: 150 }}>$0.41</td>
                </tr>
                <tr
                  style={{
                    ...styles.tr,
                    background: "#ECF1F6",
                  }}
                >
                  <td style={styles.td}>
                    <b><x-lang>Statement Charges</x-lang>:</b>
                  </td>
                  <td style={{ ...styles.td, width: 150 }}>
                    <b>$232.43</b>
                  </td>
                </tr>
              </table>
              <div
                style={{
                  ...styles.row,
                  width: "100%",
                  borderTop: "1px solid #dddddd",
                  borderBottom: "1px solid #dddddd",
                  alignItems: "center",
                  marginTop: 40,
                  paddingTop: 10,
                  paddingBottom: 10,
                }}
              >
                <b><x-lang>Total Amount Due</x-lang>:</b>
                <b>${props.data.customer.accountBalance}</b>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const styles = {
  row: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
  },
  column: {
    display: "flex",
    flexDirection: "column",
  },
  table: {
    borderCollapse: "collapse",
    width: "100%",
  },
  td: {
    border: "1px solid #dddddd",
    textAlign: "right",
    padding: 6,
  },
  tdc: {
    border: "1px solid #dddddd",
    textAlign: "center",
    padding: 6,
  },
  th: {
    border: "1px solid #dddddd",
    width: "100%",
    textAlign: "center",
    padding: 6,
  },
};

export default Invoice;
